/**
 * Zet tijdens SSR een echte HTTP-status (bijv. 404 in plaats van een soft-404).
 * In de browserbundel valt deze code weg dankzij `import.meta.env.SSR`.
 */
export async function setHttpStatus(code: number): Promise<void> {
  if (!import.meta.env.SSR) return;
  const mod = await import("./http-status.server");
  mod.setStatus(code);
}

/** Kortweg: markeer het huidige SSR-antwoord als 404. */
export function notFoundStatus(): Promise<void> {
  return setHttpStatus(404);
}
